export class HelpCenterVisitorToken {
  token = "";
  siteUrl = "";
  expiresAt = "";

  constructor(fields?: Partial<HelpCenterVisitorToken>) {
    Object.assign(this, fields);
  }
}
